<template src="./KeywordNewsList.html" />
<script>
import { QUERY_NEWS_ARTICLES_BY_KEYWORDS } from '../../../queries/NewsArticlesByKeywordsQuery';
import { ContentLoader as contentLoader } from 'vue-content-loader';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);

/**
 * キーワードニュースリスト
 * @vue-components {News/KeywordNewsList} キーワードニュースリスト
 * @module components/modules/News/KeywordNewsList
 */
export default {
  name: 'KeywordNewsList',
  components: {
    contentLoader,
  },
  props: {
    /**
     * キーワード
     * @vue-props {Array<String>}
     */
    keywords: {
      type: Array,
      default: () => [],
      required: true,
    },
    /**
     * 取得件数
     * @vue-props {Number}
     */
    limit: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      newsArticlesByKeywords: null,
    };
  },
  apollo: {
    newsArticlesByKeywords: {
      query: QUERY_NEWS_ARTICLES_BY_KEYWORDS,
      skip() {
        return true;
      },
      variables() {
        return {
          keywords: this.keywords,
          limit: this.limit,
        };
      },
    },
  },
  computed: {
    /**
     * 新着ニュースか否か
     * @return {Boolean}
     */
    isNew() {
      return (publishedAt) => {
        const date = dayjs(publishedAt);
        const now = dayjs();
        const twoHoursAgo = now.subtract(2, 'hour');
        return date.isSameOrAfter(twoHoursAgo, 'minute');
      };
    },
    /**
     * 本日のニュースか否か
     * @return {Boolean}
     */
    isToday() {
      return (publishedAt) => {
        const date = dayjs(publishedAt);
        const today = dayjs();
        return date.isSame(today, 'day');
      };
    },
    /**
     * 去年のニュースか否か
     * @return {Boolean}
     */
    isLastYear() {
      return (publishedAt) => {
        const currentYear = dayjs(publishedAt).year();
        const lastYear = dayjs().subtract(1, 'year').year();
        return currentYear === lastYear;
      };
    },
    /**
     * フォーマット済みのニュースの公開日付
     * @return {String}
     */
    formatedPublishedAt() {
      return (publishedAt) => {
        if (this.isLastYear(publishedAt)) {
          return this.formatDateToYYYYMMDD(publishedAt);
        } else if (this.isToday(publishedAt)) {
          return `今日 ${this.formatDateToHHmm(publishedAt)}`;
        } else {
          return this.formatDateToMMDDHHmm(publishedAt);
        }
      };
    },
    /**
     * ニュース記事があるか否か
     * @return {Boolean}
     */
    hasNewsArticlesByKeywords() {
      if (!this.newsArticlesByKeywords) {
        return false;
      }

      return this.newsArticlesByKeywords.articles.length > 0;
    },
    /**
     * デバイスの幅
     * @return {Integer}
     */
    getDeviseWidth() {
      return window.innerWidth;
    },
    /**
     * 表示するタグ名を変更する
     * @return {String}
     */
    displayTagName() {
      return (tag) => {
        return this.formatTagName(tag.slug) || tag.name;
      };
    },
  },
  mounted() {
    this.lazyQuery();
  },
  methods: {
    /**
     * @note mountedされるまでpropsから引数を受け取る事ができないので、mountedでskipをfalseにして、queryを発火させている
     */
    lazyQuery() {
      this.$apollo.queries.newsArticlesByKeywords.skip = false;
    },
  },
};
</script>
